export const GET_QUESTIONS_REQUEST = 'GET_QUESTIONS_REQUEST';
export const GET_QUESTIONS_FAILURE = 'GET_QUESTIONS_FAILURE';
export const SET_QUESTIONS_LIST = 'SET_QUESTIONS_LIST';
export const GET_QUESTIONS_SUCCESS = 'GET_QUESTIONS_SUCCESS';
export const SET_QUESTIONS_STATE = 'SET_QUESTIONS_STATE';
